import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { SimonField as SimonField$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';

var _excluded = ["type"];
var BlockSimonField = function BlockSimonField(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  // Users may add a SimonField in the editor, without picking a type. So don't
  // render these otherwise it crashes frontend.

  var _attrs$type = attrs.type,
    type = _attrs$type === void 0 ? 'text' : _attrs$type,
    rest = _objectWithoutProperties(attrs, _excluded);
  if (!attrs.name) {
    return null;
  }
  return /*#__PURE__*/React.createElement(SimonField$1, _extends({
    key: index,
    type: type
  }, rest));
};
BlockSimonField.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape({})
} : {};
var SimonField = BlockSimonField;

export { SimonField as default };
